import React from 'react';

const BaconMark = ({ className = '' }) => (
  <img
    className={className}
    src="/images/bacon-mark.png"
    alt=""
    width="256"
    height="256"
    aria-hidden="true"
  />
);

export default BaconMark;
